import "nprogress/nprogress.css";

import NProgress from "nprogress";
import Vue from "vue";
import VueRouter from "vue-router";

import NotFound from "../views/errorpage/404";

Vue.use(VueRouter);
const routes = [
  { path: "/", redirect: "/topo" },
  // 用户登录界面与用户登录注册界面
  {
    path: "/user",
    hideInMenu: true,
    component: () => import("../views/layout/UserLayout"),
    children: [{ path: "/user", redirect: "/topo" }],
  },
  // 拓扑界面
  {
    path: "/topo",
    name: "topo",
    menutitle: "SDNController",
    meta: { icon: "deployment-unit", title: "拓扑", isLogin: true },
    component: () => import("../views/layout/BasicLayout"),
    children: [
      { path: "/topo", redirect: "/topo/networktopo" },
      {
        path: "/topo/networktopo",
        name: "NetworkTopo",
        meta: { title: "全网拓扑" },
        component: () => import("../views/topo/NetworkTopo"),
      },
    ],
  },
  // 设备查询
  {
    path: "/devicemgr",
    name: "device",
    meta: { icon: "desktop", title: "设备查询", isLogin: true },
    menutitle: "SDNController",
    component: () => import("../views/layout/BasicLayout"),
    children: [
      { path: "/devicemgr", redirect: "/devicemgr/switchquery" },
      {
        path: "/devicemgr/terminalquery",
        name: "TerminalQuery",
        meta: { title: "终端查询", isLogin: true },
        component: () => import("../views/device/terminalQuery/TerminalQuery"),
      },
      {
        path: "/devicemgr/linkquery",
        name: "LinkQuery",
        meta: { title: "链路查询", isLogin: true },
        component: () => import("../views/device/linkQuery/LinkQuery"),
      },
      {
        path: "/devicemgr/trafficquery",
        name: "TrafficQuery",
        meta: { title: "流量查询", isLogin: true },
        component: () => import("../views/device/trafficQuery/TrafficQuery"),
      },
    ],
  },
  // 网络配置
  {
    path: "/networkmgr",
    name: "network",
    meta: { icon: "global", title: "网络配置", isLogin: true },
    menutitle: "SDNController",
    component: () => import("../views/layout/BasicLayout"),
    children: [
      { path: "/networkmgr", redirect: "/networkmgr/vport" },
      {
        path: "/networkmgr/vport",
        name: "Vport",
        meta: { title: "虚拟端口", isLogin: true },
        component: () => import("../views/network/vPort/Vport"),
      },
      {
        path: "/networkmgr/vgateway",
        name: "VGateway",
        meta: { title: "虚拟网关", isLogin: true },
        component: () => import("../views/network/vGateway/VGateway"),
      } /*
       {
         path: '/networkmgr/ippool',
         name: 'IPPool',
         meta: {title: '地址池', isLogin: true},
         component: () => import('../views/network/IPPool/IPPool')
       },
       {
         path: '/networkmgr/dhcp',
         name: 'DHCP',
         meta: {title: 'DHCP', isLogin: true},
         component: () => import('../views/network/DHCP/DHCP')
       },*/,
      {
        path: "/networkmgr/multicast",
        name: "Multicast",
        meta: { title: "组播", isLogin: true },
        component: () => import("../views/network/multicast/Multicast"),
      },
      {
        path: "/networkmgr/vlan",
        name: "Vlan",
        meta: { title: "VLAN", isLogin: true },
        component: () => import("../views/network/vlan/Vlan"),
      },
      {
        path: "/networkmgr/dscp",
        name: "DSCP",
        meta: { title: "DSCP", isLogin: true },
        component: () => import("../views/network/dscp/DSCP"),
      },
      {
        path: "/networkmgr/ratelimit",
        name: "RateLimit",
        meta: { title: "限速配置", isLogin: true },
        component: () => import("../views/network/ratelimit/RateLimit"),
      },
      {
        path: "/networkmgr/nat",
        name: "NAT",
        meta: { title: "NAT映射配置", isLogin: true },
        component: () => import("../views/network/nat/NAT"),
      },
      {
        path: "/networkmgr/portconfig",
        name: "PortConfig",
        meta: { title: "端口配置", isLogin: true },
        component: () => import("../views/network/portconfig/PortConfig"),
      },
      {
        path: "/networkmgr/porttypemanagement",
        name: "PortTypeManagement",
        meta: { title: "端口类型管理", isLogin: true },
        component: () =>
          import("../views/network/portconfig/PortTypeManagement"),
      },
      {
        path: "/networkmgr/customforward",
        name: "CustomForward",
        meta: { title: "自定义转发", isLogin: true },
        component: () => import("../views/network/customforward/CustomForward"),
      },
      {
        path: "/networkmgr/eastwest",
        name: "EastWest",
        meta: { title: "东西向协议", isLogin: true },
        component: () => import("../views/network/eastwest/EastWest"),
      },
    ],
  } /*
  //QOS管理
  {
    path: "/policy",
    name: "policy",
    meta: { icon: "global", title: "策略管理", isLogin: true },
    menutitle: "SDNController",
    component: () =>
      import("../views/layout/BasicLayout"),
    children: [
      {
        path: "/policy",
        redirect: "/policy/acl"
      },
      {
        path: "/policy/acl",
        name: "ACL",
        meta: { title: "访问控制列表", isLogin: true },
        component: () =>
          import("../views/policy/acl/ACL")
      },
      {
        path: "/policy/qos",
        name: "Qos",
        meta: { title: "限速管理", isLogin: true },
        component: () =>
          import("../views/policy/qos/Qos")
      },
      {
        path: "/policy/balance",
        name: "Balance",
        meta: { title: "负载均衡", isLogin: true },
        component: () =>
          import(
            "../views/policy/balance/Balance"
          )
      },
      {
        path: "/policy/linkagg",
        name: "LinkAgg",
        meta: { title: "链路聚合", isLogin: true },
        component: () =>
          import(
            "../views/policy/linkAgg/LinkAgg"
          )
      }
    ]
  }*/,
  // 路由管理
  {
    path: "/routemgr",
    name: "route",
    meta: { icon: "global", title: "路由管理", isLogin: true },
    menutitle: "SDNController",
    component: () => import("../views/layout/BasicLayout"),
    children: [
      { path: "/routemgr", redirect: "/routemgr/ospf" },
      {
        path: "/routemgr/ospf",
        name: "OSPF",
        meta: { title: "OSPF", isLogin: true },
        component: () => import("../views/route/ospf/OSPF"),
      },
      {
        path: "/routemgr/bgp",
        name: "BGP",
        meta: { title: "BGP", isLogin: true },
        component: () => import("../views/route/bgp/BGP"),
      },
      {
        path: "/routemgr/rip",
        name: "RIP",
        meta: { title: "RIP", isLogin: true },
        component: () => import("../views/route/rip/RIP"),
      },
      {
        path: "/routemgr/pim",
        name: "PIM",
        meta: { title: "PIM", isLogin: true },
        component: () => import("../views/route/pim/PIM"),
      } /*
       {
         path: "/routemgr/staicroutev4",
         name: "StaicRouteV4",
         meta: { title: "静态路由V4", isLogin: true },
         component: () =>
           import("../views/route/staticRouteV4/StaicRouteV4")
       },
       {
         path: "/routemgr/staicroutev6",
         name: "StaicRouteV6",
         meta: { title: "静态路由V6" ,isLogin: true },
         component: () =>
           import(/!* webpackChunkName: "qosmgr"*!/
       "../views/route/staticRouteV6/StaicRouteV6")
       },*/,
      {
        path: "/routemgr/sysroute",
        name: "SysRoute",
        meta: { title: "系统路由表", isLogin: true },
        component: () => import("../views/route/sysRoute/SysRoute"),
      },
    ],
  },
  // 链路选优策略
  {
    path: "/linkoptimization",
    name: "linkoptimization",
    meta: { icon: "branches", title: "链路选优策略", isLogin: true },
    menutitle: "SDNController",
    component: () => import("../views/layout/BasicLayout"),
    children: [
      { path: "/linkoptimization", redirect: "/linkoptimization/strategy" },
      {
        path: "/linkoptimization/strategy",
        name: "LinkOptimizationStrategy",
        meta: { title: "策略配置", isLogin: true },
        component: () => import("../views/linkOptimization/LinkOptimization"),
      },
    ],
  },
  // 系统管理
  {
    path: "/sysmgr",
    name: "system",
    meta: { icon: "laptop", title: "系统管理", isLogin: true },
    menutitle: "SDNController",
    component: () => import("../views/layout/BasicLayout"),
    children: [
      { path: "/sysmgr", redirect: "/sysmgr/userMgr" },
      /*
    {
      path: "/sysmgr/sysprocess",
      name: "SysProcess",
      meta: { title: "系统进程" ,isLogin: true },
      component: () =>
        import(/!* webpackChunkName: "sysmgr"*!/
    "../views/sysmgr/sysProcess/SysProcess")
    },
      {
        path: "/sysmgr/sysLog",
        name: "SysLog",
        meta: { title: "系统日志", isLogin: true },
        component: () => import("../views/sysmgr/sysLog/SysLog")
      },*/
      {
        path: "/sysmgr/sysConfig",
        name: "SysConfig",
        meta: { title: "系统配置", isLogin: true },
        component: () => import("../views/sysmgr/sysConfig/SysConfig"),
      },
      {
        path: "/sysmgr/sysVersion",
        name: "SysVersion",
        meta: { title: "系统版本", isLogin: true },
        component: () => import("../views/sysmgr/sysVersion/SysVersion"),
      } /*,
      {
        path: "/sysmgr/paraconfig",
        name: "ParaConfig",
        meta: { title: "参数查询" ,isLogin: true },
        component: () =>
          import("../views/sysmgr/paraConfig/ParaConfig")
      }*/,
    ],
  } /*
  //网管设置
  {
    path: "/netmgr-setting",
    name: "netmgr-setting",
    meta: { icon: "laptop", title: "网管设置" ,isLogin: true },
    menutitle: "SDNNetMgr",
    component: () =>
        import("../views/layout/BasicLayout"),
    children: [
        {
            path: "/netmgr-setting/netmgrsetting",
            name: "netmgrsetting",
            meta: { title: "系统设置" ,isLogin: true },
            component: () =>
                import("../views/netmgr/netMgrSetting/NetMgrSetting")
        }
    ]
  },*/,
  {
    path: "/netmgr-fun",
    name: "netmgr-fun",
    meta: { icon: "laptop", title: "网管功能", isLogin: true },
    menutitle: "SDNNetMgr",
    component: () => import("../views/layout/BasicLayout"),
    children: [
      {
        path: "/netmgr-fun/netmgrfun",
        name: "netmgrfun",
        meta: { title: "功能", isLogin: true },
        component: () => import("../views/netmgr/netMgrFun/NetMgrFun"),
      },
    ],
  },
  { path: "*", name: "404", hideInMenu: true, component: NotFound },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  NProgress.start();
  next();
});

router.afterEach(() => {
  NProgress.done();
});

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

export default router;
